import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSite } from "@/context/SiteContext";

const Footer = () => {
  const { config } = useSite();
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;
  return (
    <footer className="bg-ahm-teal text-ahm-cream relative overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <h2 className="font-display text-5xl md:text-7xl leading-[0.95] tracking-tight text-balance">
              Let's make something <em className="text-ahm-yellow not-italic">worth remembering.</em>
            </h2>
            <Link to="/contact" className="inline-flex mt-8 btn-pill bg-ahm-orange hover:bg-ahm-yellow hover:text-ahm-teal" data-testid="footer-contact-cta">
              Start a project
              <span className="rotate-[30deg]">→</span>
            </Link>
          </div>
          <div className="md:col-span-3 text-sm space-y-3">
            <div className="text-ahm-yellow uppercase tracking-[0.2em] text-xs font-semibold">Studio</div>
            <p className="leading-relaxed text-ahm-cream/85">{config.address}</p>
            <p className="text-ahm-cream/85">{config.phone}</p>
            <p className="text-ahm-cream/85">{config.email}</p>
          </div>
          <div className="md:col-span-3 text-sm space-y-3">
            <div className="text-ahm-yellow uppercase tracking-[0.2em] text-xs font-semibold">Navigate</div>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-ahm-orange">Home</Link></li>
              <li><Link to="/services" className="hover:text-ahm-orange">Services</Link></li>
              <li><Link to="/creatives" className="hover:text-ahm-orange">Creatives</Link></li>
              <li><Link to="/about" className="hover:text-ahm-orange">About Us</Link></li>
              <li><Link to="/blogs" className="hover:text-ahm-orange">Blogs</Link></li>
              <li><Link to="/contact" className="hover:text-ahm-orange">Contact Us</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-ahm-cream/15 flex flex-col md:flex-row justify-between gap-4 text-xs uppercase tracking-[0.2em] text-ahm-cream/55">
          <div>© {new Date().getFullYear()} {config.company_name} — All rights reserved.</div>
          <div className="flex items-center gap-6">
            <span>{config.footer_text}</span>
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-ahm-yellow">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
